module.exports = __webpack_public_path__ + "static/media/celo_symbol.6f5055bf.png";